import { takeLatest, all, takeEvery } from 'redux-saga/effects'; // fork, take,  takeEvery, takeLeading
import { SAGA_ACTIONS } from '../../_config';

import * as userSaga from './userSaga';
import * as profileSaga from './profileSaga';
import * as masterSaga from './masterSaga';
import { profile } from 'console';



export function* sagas() {
	yield all([
		takeEvery(SAGA_ACTIONS.USER.LOGIN, userSaga.login),
		takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
		takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword),
		/* takeEvery(SAGA_ACTIONS.USER.REGISTER, userSaga.register),
		takeEvery(SAGA_ACTIONS.USER.FORGET_PASSWORD, userSaga.forgotPassword),
		takeEvery(SAGA_ACTIONS.USER.RESET_PASSWORD, userSaga.resetPassword), */

		takeEvery(SAGA_ACTIONS.MASTER.GET_LICENSES, masterSaga.getLicensesList),
		takeEvery(SAGA_ACTIONS.MASTER.GET_LANGUAGES, masterSaga.getLanguagesList),
		takeEvery(SAGA_ACTIONS.MASTER.GET_COMPANY, masterSaga.getCompanyList),
		takeEvery(SAGA_ACTIONS.MASTER.GET_MASTER_MODULE, masterSaga.getMasterModuleList),



		takeEvery(SAGA_ACTIONS.PROFILE.UPDATE, profileSaga.updateProfile),


		 takeEvery(SAGA_ACTIONS.USER.LOGOUT, userSaga.logout), 




	]);
}